import * as types from '../types'

// 变量名
const defaultState = {
  commonData: null,
  userInfo: {},
  currentBench:{},//当前工作台
}

/**
 * 首页数据 reducer
 * state: 默认值为defaultState
 * action：调用时需要传的参数
 * */
export default function limits(state = defaultState, action = {}) {
  const { 
    type,     // 调用时传的方法名
    payload     // 调用时传的参数
  } = action
  const res = Object.assign({}, state)
  switch (type) {
    // 添加菜单数据
    case types.ADD_COMMON_DATA:
      res.commonData = payload.obj
      localStorage.setItem('commonItem', JSON.stringify(payload.obj))
      // return Object.assign({}, state, { menuData:  payload.data})
      break
    // 更新用户数据
    case types.UPDATE_USER_INFO:
      res.userInfo = payload.obj
      return Object.assign({}, state, {userInfo: payload.obj})
      break
      // 更新用户工作台数据
    case types.WORKBENCH_INFO:
      res.currentBench = payload.obj
      // console.log("Object.assign",payload.obj)
      localStorage.setItem(types.WORKBENCH_INFO, JSON.stringify(payload.obj))
      return Object.assign({}, state, {currentBench: payload.obj})
      break

  }
  return res
}